import { createNamespacedHelpers } from "vuex-composition-helpers";
export const STORE_NAME = "ApplicationStore";
const {
  useActions,
  useGetters,
  useMutations,
  useState
} = createNamespacedHelpers(STORE_NAME);
export const useApplicationStoreActions = useActions;
export const useApplicationStoreGetters = useGetters;
export const useApplicationStoreMutations = useMutations;
export const useApplicationStoreState = useState;